export default "__VITE_ASSET__B334XNhK__"